"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertiesSoldWrapper$ = exports.PropertiesSoldWrapper$outboundSchema = exports.PropertiesSoldWrapper$inboundSchema = void 0;
exports.propertiesSoldWrapperToJSON = propertiesSoldWrapperToJSON;
exports.propertiesSoldWrapperFromJSON = propertiesSoldWrapperFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const propertiessold_js_1 = require("./propertiessold.js");
const propertiessoldbypropertytype_js_1 = require("./propertiessoldbypropertytype.js");
/** @internal */
exports.PropertiesSoldWrapper$inboundSchema = z.object({
    national: propertiessold_js_1.PropertiesSold$inboundSchema,
    property_type: z.array(propertiessoldbypropertytype_js_1.PropertiesSoldByPropertyType$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "property_type": "propertyType",
    });
});
/** @internal */
exports.PropertiesSoldWrapper$outboundSchema = z.object({
    national: propertiessold_js_1.PropertiesSold$outboundSchema,
    propertyType: z.array(propertiessoldbypropertytype_js_1.PropertiesSoldByPropertyType$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        propertyType: "property_type",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PropertiesSoldWrapper$;
(function (PropertiesSoldWrapper$) {
    /** @deprecated use `PropertiesSoldWrapper$inboundSchema` instead. */
    PropertiesSoldWrapper$.inboundSchema = exports.PropertiesSoldWrapper$inboundSchema;
    /** @deprecated use `PropertiesSoldWrapper$outboundSchema` instead. */
    PropertiesSoldWrapper$.outboundSchema = exports.PropertiesSoldWrapper$outboundSchema;
})(PropertiesSoldWrapper$ || (exports.PropertiesSoldWrapper$ = PropertiesSoldWrapper$ = {}));
function propertiesSoldWrapperToJSON(propertiesSoldWrapper) {
    return JSON.stringify(exports.PropertiesSoldWrapper$outboundSchema.parse(propertiesSoldWrapper));
}
function propertiesSoldWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PropertiesSoldWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PropertiesSoldWrapper' from JSON`);
}
//# sourceMappingURL=propertiessoldwrapper.js.map